import "./MainIntro.scss";
import cn from "classnames";

interface Props {
  mainIntro?: string;
  mainIntroPropertyName?: string;
}

const MainIntro = ({ mainIntro, mainIntroPropertyName }: Props) => (
  <div className="main-intro-norad">
    {(mainIntro || mainIntroPropertyName) && (
      <p
        className={cn({
          "epi-editContainer": mainIntroPropertyName,
        })}
        data-epi-property-name={mainIntroPropertyName}
      >
        {mainIntro}
      </p>
    )}
  </div>
);

export default MainIntro;
